module.exports = __webpack_public_path__ + "img/icon-chat-mood-happy.97d11c3a.svg";